export const documentIcons = {
  CPOA: "/images/Address Proof.svg",
  PPOA: "/images/Address Proof.svg",
  POI: "/images/Photo ID Proof.svg",
  Sign: "/images/Signature.svg",
  Photo: "/images/Photo.svg",
  BaPr: "/images/Bank-Proof.svg",
  IPV: "/images/IPV (Video Recording).svg",
  Oth: "/images/Signature.svg",
};

export const documentTypePerName = {
  CPOA: "Corresponding Address",
  PPOA: "Permanent Address",
  POA: "Power of Attorney",
  POI: "Proof Of Identity",
  Sign: "Signature",
  Photo: "Photograph",
  KYCP: "KYC Proof",
  DePr: "Demat Proof",
  BaPr: "Bank Proof",
  InPr: "Income Proof",
  Nom: "Nominee Proof",
  Gurd: "Guardian Proof",
  IPV: "In-Person Verification",
  KRA: "KYC KRA Page",
  default: "Document Upload",
  BalSh: "Copy of Balance sheet of past two years",
  AuSig: "Authorised Signatory on letter head of Firm/Company",
  ITR: "IT Return for last 2 financial years",
  PDeed: "Partnership  deed",
  PCapR: "Partnership capital ratio",
  DMapL: "Demat account Mapping Letter",
  MOA: "MOA and AOA of the company",
  Annx: "Annexure page",
  BoRes: "Board Resolution",
  NetWo: "Net Worth Certificate",
  RCert: "Registration Certificate",
  Oth: "Others",
};

function checkForValidDocumentType(docName, accept) {
  let isValidDocumentType = false;
  if (accept) {
    if (accept.includes('pdf')) {
      if (docName.toLowerCase().includes('pdf') || docName.toLowerCase().includes('jpg') || docName.toLowerCase().includes('png') || docName.toLowerCase().includes('jpeg') || docName.toLowerCase().includes('svg')) {
        isValidDocumentType = true
      }
    } else if (accept.includes('jpg')) {
      if (docName.toLowerCase().includes('jpg') || docName.toLowerCase().includes('png') || docName.toLowerCase().includes('jpeg') || docName.toLowerCase().includes('svg')) {
        isValidDocumentType = true
      }
    }
  } else if (docName.toLowerCase().includes('jpg') || docName.toLowerCase().includes('png') || docName.toLowerCase().includes('jpeg') || docName.toLowerCase().includes('pdf') || docName.toLowerCase().includes('svg')) {
    isValidDocumentType = true
  }
  return isValidDocumentType;
}

function checkIfPdfIsEncrypted(file) {
  const reader = new FileReader();
  reader.readAsText(file);
  let promise = new Promise((res, rej) => {
    reader.onload = (evt) => {
      try {
        if (evt.target.result.indexOf('/Encrypt') !== -1) {
          res(true);
        } else {
          res(false);
        }
      } catch (ex) {
        rej(ex || 'Please upload valid Document');;
      }
    };
  });
  return promise
}

function getBase64(file) {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  let promise = new Promise((res, rej) => {
    reader.onload = (evt) => {
      let obj = {};
      try {
        obj = { data: evt.target.result, type: file.type, size: file.size, name: file.name }
        res(obj);
      } catch (ex) {
        obj = { error: ex }
        rej(obj);
      }
    };
  });
  return promise;
}

export async function onFileSelection(file, accept) {
  if (checkForValidDocumentType(file.name.toLowerCase(), accept)) {
    if ((file.size / (1024 * 1024)) > 5) {
      return { show: true, message: "Proof size should be less than 5MB", type: "error" };
    } else {
      if(file.type?.includes('pdf')) {        
        let encrypted = await checkIfPdfIsEncrypted(file)
        if (encrypted) {
          return { show: true, message: 'Please remove the password before uploading pdf', type: 'error' }
        } else {
          return await getBase64(file)
        }
      } else {
        return await getBase64(file)
      }
    }
  } else {
    return { show: true, message: "Please upload valid Document Format", type: "error" };
  }
}
